
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import Vue from 'vue';

import StatusBar from '../components/StatusBar.vue';
import PopupPickerSelector from '../components/PopupPickerSelector.vue';
import InlineSwitch from '../components/InlineSwitch.vue';
import InlineCheckBox from '../components/InlineCheckBox.vue';

import Datetime from 'vux/src/components/datetime/index.vue';
import Group from 'vux/src/components/group/index.vue';
import XDialog from 'vux/src/components/x-dialog/index.vue';
import PopupPicker from 'vux/src/components/popup-picker/index.vue';
import { TransferDomDirective as TransferDom } from 'vux/src/directives/transfer-dom/index.js';

import utils from '../utils/index';
import CONSTANTS from '../constants/index';
import { RISK_OPTION_XNY, RISK_LIMITS_LINK_XNY } from '../constants/index';
import SNKH5Uploader from 'snk-image-js/lib/h5/uploader'
import { promises } from 'fs';
import { inspect } from 'util';


export default {
name: 'home',
data() {
return {
uploaderInstance: {},
servicesRisk: {
'030134':false,
'030135':false,
'030136':false,
'030137':false,
},
vas: ['030134', '030135', '030136', '030137'], // 增值服务
dateControl: null,
isShowAll: false,
isCalculatingPremiun: false,
hasCalPremiunFlag: false,
calPremiumResult: {}, // 保费试算结果
defaultQuoteRisk: ['030101', '030102', '030104', '030105'], // 默认报价险种 : 车损险  三者险  司机险  乘客险
latelyVersionList: utils.deepClone(CONSTANTS.LATELY_VERSION_LIST_XNY), // 展示暂存单里的险别
jqFlag: false,
syFlag: false,
choosenSylist: [],
riskTips: utils.deepClone(CONSTANTS.RISK_TIPS_XNY),
newRiskList: utils.deepClone(CONSTANTS.COVERAGE_NEW),
syRiskList: utils.deepClone(CONSTANTS.COVERAGE_List_XNY).filter(item => item.kindCode !== '021'),
syRisk: utils.deepClone(CONSTANTS.XNY_RISK),
jqRisk: utils.deepClone(CONSTANTS.JQ_RISK),
PICKER_OPTIONS: {
'030102': [],
'030104': [],
'030105': [],
'030110': [],
'030112': [],
'030120': [],
'030134': [],
'030135': [],
'030136': [],
'030137': [],
'030139': [],
'030140': [],
'030156': [],
'030153': [],
'030154': [],
'rate030101': [],
'rate030102': [],
'rate030104': [],
'rate030105': [],
'03013701': []
},
DEDUC_OPTIONS: [],
costCom: [],
temp030154Arr: [], // 用于030154临时存放值
PICKER_OPTIONS_030154: [], // 用于030154下拉选项
}
},
computed: {
...mapGetters({
getSyRisk: 'quote/getSyRisk',
getJqRisk: 'quote/getJqRisk',
getChargingPileList: 'quote/getChargingPileList',
getSwitchList:'quote/getSwitchList'
}),
...mapState({
minuteList: 'minuteList',
flowId: 'flowId',
quoteInfo: state => state.quote.quoteInfo,
electronicPolicyFlag: state => state.quote.electronicPolicyFlag,

insuredTips: (state) => state.insuredTips,
applicantTips: (state) => state.applicantTips,
switchList: state => state.quote.switchList,
cacheRecordInfo: (state) => state.quote.cacheRecordInfo,
sdQuoteInfo: state => state.quote.sdQuoteInfo,
isSdjg: state => state.isSdjg,
isHc: state => state.isHc,
}),
temp030154Val() {
return this.temp030154Arr[0];
},
annualInspectionAge() {
/**
* 年检车龄计算公式：[3个月 +（保险止期年-初登日期的年）*12  +（保险止期月-初登日期的月） +[（保险止期日-初登日期的日）小于0则减1个月，否则不减]]/12，；
* 结果舍去小数。
* 大于等于6年，需过线1，否则免过线0（赠送1次）
*/
let _syEndDate = utils.beautyFormatDate(`${this.getSyRisk.endDate}`, 'yyyy-mm-dd'),
_v_singeinDate = utils.beautyFormatDate(`${this.quoteInfo.vehicle.singeinDate}`,'yyyy-mm-dd'),
_endDate = new Date(_syEndDate.replace(/[-]/g, '/')),
_endDateY = _endDate.getFullYear(),
_endDateM = _endDate.getMonth() + 1,
_endDateD = _endDate.getDate(),
_singeinDate = new Date(_v_singeinDate.replace(/[-]/g, '/')),
_singeinDateY = _singeinDate.getFullYear(),
_singeinDateM = _singeinDate.getMonth() + 1,
_singeinDateD = _singeinDate.getDate(),
_subM = _endDateD - _singeinDateD > 0 ? 0 : -1,
age = Math.floor((3 + (_endDateY - _singeinDateY) * 12 + (_endDateM - _singeinDateM) + _subM) / 12);
return age;
},
deptNo() { // 机构代码
return (
this.quoteInfo.base &&
this.quoteInfo.base.companyCode &&
this.quoteInfo.base.companyCode.slice(0, 4)
);
},
},
components: {
StatusBar,
InlineCheckBox,
Datetime,
Group,
PopupPickerSelector,
PopupPicker,
InlineSwitch,
XDialog,
},
directives: {
TransferDom,
},
methods: {
...mapMutations({
setRiskList: 'quote/setRiskList',
clearRiskList: 'quote/clearRiskList',
setJqrisk: 'quote/setJqrisk',
setSyrisk: 'quote/setSyrisk',
setQuoteInfo: 'quote/setQuoteInfo',
setRiskFlag: 'quote/setRiskFlag',
setCalPremiumResult: 'quote/setCalPremiumResult',
setOtaVehicle: 'quote/setOtaVehicle',
}),
...mapActions({
copy: 'quote/copy',
queryCoverQuote: 'quote/queryCoverQuote',
depreciation: 'quote/depreciation',
queryVhlTaxRelief: 'quote/queryVhlTaxRelief',
officialApply: 'quote/officialApply',
}),

getTaxRelifFlag() {
let taxRelifFlag = ''

switch(this.calPremiumResult.vhlTax.taxRelifFlag) {
case '01':
taxRelifFlag = '拒缴'
break;
case '02':
taxRelifFlag = '缴税'
break;
case '03':
taxRelifFlag = '完税'
break;
case '04':
taxRelifFlag = '减税'
break;
case '05':
taxRelifFlag = '免税'
break;
case '06':
taxRelifFlag = '补税并纳税'
break;
}
return taxRelifFlag;
},

getFuelType() {



const fuelTypeKey = this.calPremiumResult.vhlTax.fuelType;
let fuelType = ''

if (this.deptNo === '0107') {

const found = CONSTANTS.BJ_POWER_TYPE_LIST.find(item => item.key === fuelTypeKey);
fuelType = found.name;
} else {

const found = CONSTANTS.POWER_TYPE_LIST.find(item => item.key === fuelTypeKey);
fuelType = found.name;
}
return fuelType;
},

async getQuotaLimitList() {
try {
const { vehicle, base } = this.quoteInfo
let useType = '02'

if (vehicle.carKindCode === '100' && Number(vehicle.seatCount) <= 9 && base.busiAttrConfig.useNatures === '02') {
useType = '01'
}
const data = {
useNatures: base.busiAttrConfig.useNatures, // 1107 新加的参数
attachNature: vehicle.attachNature, // 1107 新加的参数
carKindCode: vehicle.carKindCode, // 1107 新加的参数
orgNo: base.companyCode,
useType
}
const res = await $http.queryAutoRiskQuotaLimitList({ data })
if (res.resultCode === '0' && res.result && res.result.length > 0) {

const szx = res.result.find(item => item.riskType === '030102')
if (!szx) return
this.syRiskList.forEach(risk => {
if (risk.kindCode === '030102') {

risk.sumInsured = szx.quotaLimit
}
})
}
} catch (error) {
console.log(error);
}
},
handleShow(kindCode) {
let vm = this;
let _show = true;
if (vm.vas.includes(kindCode)) {

}
return _show;
},
handleReadonly(kindCode) {
let vm = this;
let _readonly = false;
if (vm.vas.includes(kindCode)) {
_readonly = vm.servicesRisk[kindCode];
}
return _readonly;
},
handleZzfw(riskList) {
let vm = this;
let _sy = riskList && riskList.find(item => item.riskCode == CONSTANTS.XNY_RISK_CODE);
let _coverageList = _sy && _sy.coverageList;



for (let index = 0, len = vm.syRiskList.length; index < len; index++) {
let item = vm.syRiskList[index];
if (vm.vas.includes(item.kindCode)) {
let _coverageList_item = _coverageList && _coverageList.find(x=>x.kindCode==item.kindCode);
let _status = _coverageList ? !!_coverageList_item : false;

item.isShow = _status;
item.checked = _status;
item.quantity = _status && _coverageList_item.quantity || 0;
}
}
},
saveToStore() {

let self = this;
return new Promise(function (resolve, reject) {

let _quoteInfo = utils.deepClone(self.quoteInfo) || {};

let _riskList = utils.deepClone(self.encapRiskSY()) || [];
_quoteInfo.riskList = _riskList;
self.setQuoteInfo(_quoteInfo);
resolve(_quoteInfo);
});
},
getIsChecked(kindCode) {
let _primary = this.syRiskList.find(item => item.kindCode === kindCode);
return (_primary && _primary.checked);
},
toCharging(kindCode, startDate) {
let vm = this;
let chekedItems = [];
let isChecked = this.getIsChecked(kindCode);
if (!isChecked) {
Toast(`亲，请先投保${this.riskTips[kindCode].name}！`);
return false;
}
['030153','030154'].forEach(x => {
if (this.getIsChecked(x)) {
chekedItems.push(x);
}
})
this.saveToStore().then(res => {

setTimeout(() => {
vm.$router.push({
params: {
startDate,
chekedItems,
},
path: '/charging_pile',
name: 'ChargingPile'
})
}, 200);
});
},
setRiskOption030154(_val='', _name='其他') {

let _otherItem = this.PICKER_OPTIONS_030154.slice(-1); 
if (_otherItem.name !== _name || _otherItem.value !== _val) {

let _opt = utils.deepClone(RISK_OPTION_XNY['030154'].premiumList).concat({name:_name,value:_val});
this.PICKER_OPTIONS_030154 = [_opt];
}
},
initalRiskValue() {

let _risk_cost_030101 = this.syRiskList.find(item => item.kindCode === '030101');
let _risk_cost_030152 = this.syRiskList.find(item => item.kindCode === '030152');
if (_risk_cost_030152 && _risk_cost_030101) {
_risk_cost_030152.sumInsured = _risk_cost_030101.sumInsured;
}

let _risk_cost_030154 = this.syRiskList.find(item => item.kindCode === '030154') || {};
if (this.temp030154Val !== _risk_cost_030154.unitInsured) {
this.temp030154Arr = [_risk_cost_030154.unitInsured];
}

this.syRiskList.forEach((item,index) => {



if(item.kindCode === '030140'){
let insured_030140 = this.PICKER_OPTIONS['030140'].find( opt => opt.value== item.sumInsured )
if(!insured_030140) {
item.sumInsured = '200000'
}
}
});
},
initalRiskOption() {

for (let opt in this.PICKER_OPTIONS) {
let option = [
RISK_OPTION_XNY[opt].premiumList
];
if (opt === '030112') {
option.push(RISK_OPTION_XNY[opt].premiumList2);
}
this.PICKER_OPTIONS[opt] = option;
}

this.DEDUC_OPTIONS.push(RISK_OPTION_XNY['deductibleList']);

let _risk_cost = this.syRiskList.find(item => item.kindCode === '030112');
this.costCom[0] = _risk_cost ? _risk_cost.unitInsured : 0;
this.costCom[1] = _risk_cost ? _risk_cost.quantity : 0;
this.setRiskOption030154();
},
initalRiskLimit() {
let _syRiskList =  utils.deepClone(this.syRiskList);

if (this.quoteInfo.vehicle.seatCount > 9) {
let vas = ['030134', '030135', '030136', '030137']; 
_syRiskList = _syRiskList.filter(item => vas.indexOf(item.kindCode) < 0);
}
/**
* 030152，要满足条件才放入syrisklist
* 依赖于：车损险且能源种类限制为插电式混合动力或纯电动
*/
if (!['1','3'].includes(this.quoteInfo.vehicle.powerTypeCode)) {
let vas = ['030152'];
_syRiskList = _syRiskList.filter(item => vas.indexOf(item.kindCode) < 0);
}
this.syRiskList = _syRiskList;
},
getInsuranceType(kindCode) {
let input = ['030101']; 
let input2 = [];
let input3 = ['030144', '030155']; 
let input4 = ['030141', '030142', '030145', '030146']; 
let input5 = ['030152']; 
let input6 = ['030153', '030154']; 
let picker = ['030102', '030110', '030120', '030139','030140']; 
let picker2 = ['030134','030135', '030136']; 
let picker3 = ['rate030101', 'rate030102', 'rate030104', 'rate030105']; 
let picker4 = ['030156']; 
let complex = ['030104', '030105']; 
let complex2 = ['030112']; 
let complex3 = ['030137']; 
let typeObj = {
input,
input2,
input3,
input4,
input5,
input6,
picker,
picker2,
picker3,
picker4,
complex,
complex2,
complex3,
};
for (let key in typeObj) {
if (typeObj[key].indexOf(kindCode) > -1) {
return key;
}
}
return 'others';
},




getRiskLimits(riskCode) {
let primarys = [];
let risk_limits = RISK_LIMITS_LINK_XNY;
for (let i = 0; i < risk_limits.length; i++) {
let secondarys = risk_limits[i].secondary;
secondarys.indexOf(riskCode) > -1 && primarys.push(risk_limits[i].primary);
}
if (primarys.length === 0) {
return true;
} else {
for (let m = 0; m < primarys.length; m++) {
let _primary = this.syRiskList.find(item => item.kindCode === primarys[m]);
if (_primary.checked) {
return true;
}
}
return false;
}
},

hasCoverageSd(kindCode) {
if (this.sdQuoteInfo && this.sdQuoteInfo.riskList) {
const riskSy = this.sdQuoteInfo.riskList.find(item => item.riskCode === CONSTANTS.SY_RISK_CODE) || {};
if (Array.isArray(riskSy.coverageList)) {
return riskSy.coverageList.findIndex(item => item.kindCode === kindCode) !== -1;
}
}
return false;
},
getRiskName(kindCode) {
for (let i = 0; i < CONSTANTS.COVERAGE_List_XNY.length; i++) {
if (kindCode === CONSTANTS.COVERAGE_List_XNY[i].kindCode) {
return CONSTANTS.COVERAGE_List_XNY[i].name;
}
}
return '';
},
getSeatcount(item) {
let seatCountArr = ['030105', '030142', '030146']; 
return seatCountArr.indexOf(item.kindCode) > -1 ? item.quantity + '座' : '';
},
formatCostPopupPicker(costCom) {
return `${costCom[0]}元*${costCom[1]}天`;
},
setSeatCount() {
let drivers = ['030104', '030141', '030145']; 
let passers = ['030105', '030142', '030146']; 
let seatCount = this.quoteInfo.vehicle.seatCount;
let driverCount = seatCount == 0 ? 0 : 1;
let passerCount = seatCount == 0 ? 0 : seatCount - 1;
for (let i = 0; i < this.syRiskList.length; i++) {
if (drivers.indexOf(this.syRiskList[i].kindCode) > -1) {
this.syRiskList[i].quantity = driverCount;
} else if (passers.indexOf(this.syRiskList[i].kindCode) > -1) {
this.syRiskList[i].quantity = passerCount;
}
}
},
showDatetime(initValue, type) {
let vm = this;
let opts = {
startDate: this.dateControl.startDate,
cancelText: '取消',
confirmText: '确定',
minuteList: this.minuteList,
value: initValue.slice(0, 16),
onConfirm(val) {
let startDate;
if (type == "jq") {
startDate = `${val}:00:00`;
} else if (type == "sy") {
startDate = `${val}:00`;
}
if (new Date(startDate.replace(/[-]/g, '/')) < new Date()) {
Toast("保险起期需大于当前时间");
return false;
}
if (type == "jq") {
vm.jqRisk.startDate = `${val}:00`;
} else if (type == "sy") {
vm.syRisk.startDate = val;
}
},
};
switch (type) {
case "jq":
opts = Object.assign({}, opts, {
format: 'YYYY-MM-DD HH',
})
break;
case "sy":
opts = Object.assign({}, opts, {
format: 'YYYY-MM-DD HH:mm',
})
break;
};

vm.$vux.datetime.show(opts);
},
jqStartDateChange(value) {
this.jqRisk.startDate = value + ":00";
if (new Date(this.jqRisk.startDate) < new Date()) {
Toast("保险起期需大于当前时间");
return false;
}
},
toNext() {
this.setRiskFlag({
jqFlag: this.jqFlag,
syFlag: this.syFlag,
});

let validate = this.validatePremium();
if (!validate.valid) {
this.$vux.toast.show({
text: validate.msg,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em'
});
return false;
}
this.$router.push({ name: 'SubmitOrder' });

},
formatValueFunction(val) {
let newVal = val.replace(/(\d{4}-\d{2}-\d{2} \d{2}:\d{2})(:\d{2})/g, '$1');
return newVal
},

onSyStartDateChange(value) {
let vm = this;
let startDate = utils.beautyFormatDate(`${vm.syRisk.startDate}`, 'yyyy-mm-dd hh:mm:ss');
vm.depreciation(startDate)
.then(actualValue => {
vm.resetInsured(actualValue);

})
.catch(err => {
Toast(err);
})
},

showRiskTips(riskIndex) {
let vm = this;
let TIPS_ITEM = this.riskTips[vm.syRiskList[riskIndex].kindCode]; 
if (!TIPS_ITEM) return;
let tips = TIPS_ITEM.tips;

vm.$vux.confirm.show({
title: '提示',
content: tips,
showCancelButton: false,
})
},

quotaChange(index) {
let vm = this;
let title, placeholder, upRatio, downRatio;
if (index === 0) {

title = '修改车辆损失险';

downRatio = 0.8;
placeholder = '保额最小值不能低于新车购置价20%';
} else if (index == 2) {

title = '修改全车盗抢险';

downRatio = 0.8;
placeholder = '保额最小值不能低于新车购置价20%';
} else if (index == 6) {

title = '修改自燃损失保险';

downRatio = 0.8;
placeholder = '保额最小值不能低于新车购置价20%';
}


let newAmt = Number(vm.quoteInfo.vehicle.purchasePrice); 
let vhlAmt = Number(vm.quoteInfo.vehicle.actualValue); 


vm.$vux.confirm.prompt(placeholder, {
title,
inputAttrs: { maxlength: 10 },
onCancel() {},
onConfirm(value) {
let valiAmt = Number(value); 
let minAmt = Number((vhlAmt - vhlAmt * downRatio).toFixed(2)); 

if (isNaN(Number(value))) {
vm.$vux.toast.show({
text: '请输入合法的保额数据',
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em',
});
return;
} else {
if (index == 0) { // 车损险

if (valiAmt < minAmt) {
vm.$vux.toast.show({
text: '保额修改不得低于' + minAmt,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em',
});
return;
} else {
vm.syRiskList[index].sumInsured = utils.limitToPercent(value);
if (vm.syRiskList[index].kindCode === '030101') {
for (let i = 0; i < vm.syRiskList.length; i++) {
if (vm.syRiskList[i].kindCode === '030152') {
vm.syRiskList[i].sumInsured = vm.syRiskList[index].sumInsured; 
break;
}
}
}
}
} else if (index == 2 || index == 6) { // 盗抢险 和 自燃险
if (valiAmt < minAmt) {
vm.$vux.toast.show({
text: '保额修改不得低于' + minAmt,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em',
});
return;
} else {

vm.syRiskList[index].sumInsured = utils.limitToPercent(value);
}
}
}
}
});
},
updateCostCom(value) {
for (let i = 0; i < this.syRiskList.length; i++) {
if (this.syRiskList[i].kindCode === '030112') {
this.syRiskList[i].unitInsured = value[0];
this.syRiskList[i].quantity = value[1];
break;
}
}
},

/* T+1套上年方案逻辑(3种情况):
1: startDate < 当前时间 && 差值大于1年   year = 2018  date +1 再按2比较
2: startDate < 当前时间 && 差值小于1年   当前时间 + 1
3: startDate > 当前时间    			startDate +1
*/
reSetStartTimeAndInitRisk(type) {
/*
type : 'xzb' --> '续转保'后台返回的数据
*/
let vm = this;
let nowTime = new Date();
let nowTimeStr = `${nowTime.getFullYear()}-${nowTime.getMonth()+1}-${nowTime.getDate()}`;
if (vm.getJqRisk) {
let _jqRisk = utils.deepClone(vm.getJqRisk);
let tempTime;
if (type == "xzb") {
/* 如果是续转保: 需要取止期和当前时间比较
!!!!!!!!!   tempTime是存的止期 */

tempTime = utils.translateTimeDate(vm.getJqRisk.startDate.replace(/(\d{4})/, function(e) { return e - 0 + 1; }));
} else {
/*  如果是暂存单 或者默认设置的 : 取起期与当前时间比较
!!!!!!!!!   tempTime是存的起期 */
tempTime = utils.translateTimeDate(vm.getJqRisk.startDate);
}
let between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= -360) { // 超过一年
tempTime = tempTime.replace(/\d{4}/, nowTime.getFullYear())
between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= 0) {
_jqRisk.startDate = utils.recNexDate();
} else {
_jqRisk.startDate = utils.recNexDateSpecial(tempTime);
}
} else if (between <= 0) {
_jqRisk.startDate = utils.recNexDate();
} else if (between > 0 && type == "xzb") {
_jqRisk.startDate = utils.recNexDateSpecial(tempTime);
}
_jqRisk.endDate = utils.countEndDate(_jqRisk.startDate,'jq'); 
vm.setJqrisk(_jqRisk);
}
if (vm.getSyRisk) {
let _syRisk = utils.deepClone(vm.getSyRisk);
let tempTime;
if (type == "xzb") {
/* 如果是续转保: 需要取止期和当前时间比较
!!!!!!!!!   tempTime是存的止期 */
tempTime = utils.translateTimeDate(vm.getSyRisk.startDate.replace(/(\d{4})/, function(e) { return e - 0 + 1; }));
} else {
/*  如果是暂存单 或者默认设置的 : 取起期与当前时间比较
!!!!!!!!!   tempTime是存的起期 */
tempTime = utils.translateTimeDate(vm.getSyRisk.startDate);
}
let between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= -360) {
tempTime = tempTime.replace(/\d{4}/, nowTime.getFullYear());
between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= 0) {
_syRisk.startDate = utils.recNexDate();
} else {
_syRisk.startDate = utils.recNexDateSpecial(tempTime);
}
} else if (between <= 0) {
_syRisk.startDate = utils.recNexDate();
} else if (between > 0 && type == "xzb") {
_syRisk.startDate = utils.recNexDateSpecial(tempTime);
};
_syRisk.endDate = utils.countEndDate(_syRisk.startDate,'sy'); 

for (var i = 0; i < _syRisk.coverageList.length; i++) {
if (vm.latelyVersionList.indexOf(_syRisk.coverageList[i].kindCode) == -1) {
_syRisk.coverageList.splice(i, 1);
i--;
}
}
vm.setSyrisk(_syRisk);
}
},

getInitRiskInfo() {
let vm = this;
let liscenseNo = this.quoteInfo.vehicle.licenseNo;
let frameNo = this.quoteInfo.vehicle.frameNo;
let tempNoInfo = JSON.parse(localStorage.getItem('tempNoInfo')) || {};
let tempNo = tempNoInfo[liscenseNo] || tempNoInfo[frameNo];
vm.isCalculatingPremiun = true;
return new Promise((resolve, reject) => {
if (tempNo && vm.quoteInfo.riskList && vm.quoteInfo.riskList.length != 0) { // 有暂存单

vm.reSetStartTimeAndInitRisk();
resolve(true);
} else if (!tempNo || !vm.quoteInfo.riskList || vm.quoteInfo.riskList.length == 0) { // 续保 or 转保

vm.queryCoverQuote()
.then(riskList => {

if (riskList.length == 2) {
vm.initAndStoreRisk();
vm.reSetStartTimeAndInitRisk('xzb');
} else if (riskList.length == 1 && riskList[0].riskCode == CONSTANTS.XNY_RISK_CODE) { // 单商 --> 处理交强
vm.initAndStoreRisk('JQ');
vm.reSetStartTimeAndInitRisk('xzb');
} else if (riskList.length == 1 && riskList[0].riskCode == CONSTANTS.JQ_RISK_CODE) { // 单交 --> 处理商业
vm.initAndStoreRisk('SY');
vm.reSetStartTimeAndInitRisk('xzb');
} else if (riskList.length == 0) {
vm.initAndStoreByDefault();
}
resolve(true);
})
.catch(err => {
vm.initAndStoreByDefault();
resolve(true);
});
} else { // 默认
vm.initAndStoreByDefault();
resolve(true);
}
})
},

initAndStoreRisk(TYPE) {
let vm = this;

let _jqRisk = utils.deepClone(CONSTANTS.JQ_RISK);
if (TYPE != 'JQ') {
_jqRisk.startDate = vm.getJqRisk.startDate;
} else {
_jqRisk.startDate = utils.recTodayDate().replace(/(\d{4})/, function(e) { return e - 1; });
}
_jqRisk.endDate = utils.countEndDate(_jqRisk.startDate,'jq'); 
/* _jqRisk.vhlTax.identifyNumber =_jqRisk.vhlTax.taxpayerIdentifier = vm.quoteInfo.owner.identifyNumber;
_jqRisk.vhlTax.certiType = vm.quoteInfo.owner.identifyType || '01'; */

vm.setJqrisk(_jqRisk);

if (TYPE == 'SY') {
let _syRisk = utils.deepClone(CONSTANTS.XNY_RISK);
let _syRistList = [];
_syRisk.startDate = utils.recTodayDate().replace(/(\d{4})/, function(e) { return e - 1; });;
_syRisk.endDate = utils.countEndDate(_syRisk.startDate,'sy'); 

this.defaultQuoteRisk.forEach(kindCode => {
vm.syRiskList.forEach(syItem => {
if (kindCode == syItem.kindCode) {
_syRistList.push(syItem);
}
});
});
_syRisk.coverageList = _syRistList;

vm.setSyrisk(_syRisk);
}
},

initAndStoreByDefault() {
let vm = this;
let _ristList = [],
_syRistList = [];
let _jqRisk = utils.deepClone(CONSTANTS.JQ_RISK),
_syRisk = utils.deepClone(CONSTANTS.XNY_RISK);


_jqRisk.startDate = utils.recNexDate();
_jqRisk.endDate = utils.countEndDate(_jqRisk.startDate); 
/* _jqRisk.vhlTax.identifyNumber =_jqRisk.vhlTax.taxpayerIdentifier = vm.quoteInfo.owner.identifyNumber;
_jqRisk.vhlTax.certiType = vm.quoteInfo.owner.identifyType || '01'; */


_syRisk.startDate = utils.recNexDate();
_syRisk.endDate = utils.countEndDate(_syRisk.startDate); 

this.defaultQuoteRisk.forEach(kindCode => {
vm.syRiskList.forEach(syItem => {
if (kindCode == syItem.kindCode) {
_syRistList.push(syItem);
}
});
});
_syRisk.coverageList = _syRistList;
_ristList = [_jqRisk, _syRisk];


vm.setRiskList(_ristList);
},


initRiskInfoShowing(actualValue) {
let vm = this;

if (vm.getJqRisk) {
vm.jqFlag = true;

vm.jqRisk = utils.deepClone(vm.getJqRisk);

}

if (vm.getSyRisk) {
vm.syFlag = true;

vm.syRisk = utils.deepClone(vm.getSyRisk);

}

if (this.isSdjg) {
if (!vm.jqRisk.coverageList || vm.jqRisk.coverageList.length == 0) {
vm.jqRisk.coverageList = [{
"kindCode": "BZ",
"kindInd": "1",
"sumInsured": 200000
}];
} else if (!vm.jqRisk.coverageList[0].sumInsured) {
vm.jqRisk.coverageList[0].sumInsured = 200000;
}
}

vm.syRiskList.forEach((defaultItem, defaultIndex) => {
if (!vm.getSyRisk || !vm.getSyRisk.coverageList) {
return;
}

if(defaultItem.kindCode === '030137'&&!defaultItem.checked){
defaultItem.valueType = this.annualInspectionAge >= 6 ? '1' : '0';;
}
vm.getSyRisk.coverageList.forEach(syItem => {
if (defaultItem.kindCode === syItem.kindCode) {

syItem.checked = true;

if (this.isSdjg) {
const insuranceType = this.getInsuranceType(syItem.kindCode);
if (insuranceType === 'complex') {
if ((syItem.sumInsured && !syItem.unitInsured) || (syItem.unitInsured && !syItem.quantity)) {
const drivers = ['030104']; 
const passers = ['030105']; 
const seatCount = this.quoteInfo.vehicle.seatCount;
const driverCount = seatCount == 0 ? 0 : 1;
const passerCount = seatCount == 0 ? 0 : seatCount - 1;
if (drivers.includes(syItem.kindCode) && driverCount) {
syItem.quantity = syItem.quantity || driverCount;
syItem.unitInsured = syItem.unitInsured || (syItem.sumInsured / syItem.quantity);
} else if (passers.includes(syItem.kindCode) && passerCount) {
syItem.quantity = syItem.quantity || passerCount;
syItem.unitInsured = syItem.unitInsured || (syItem.sumInsured / syItem.quantity);
}
}
}
}
Vue.set(vm.syRiskList, defaultIndex, utils.deepClone(syItem));

if (syItem.kindCode === '030112') {
vm.costCom[0] = syItem.unitInsured;
vm.costCom[1] = syItem.quantity;
}

if (syItem.kindCode === '030101' || syItem.kindCode === '030102' || syItem.kindCode === '030104' || syItem.kindCode === '030105') {
if (syItem.deductibleRate && syItem.deductibleRate > 0) {
for (let i = 0; i < vm.syRiskList.length; i++) {
if (vm.syRiskList[i].kindCode === `rate${syItem.kindCode}`) {
vm.syRiskList[i].checked = true;
vm.syRiskList[i].disabled = false;
vm.syRiskList[i].rate = syItem.deductibleRate;
break;
}
}
}
}
}
});
});
this.resetInsured(actualValue); 
this.syRiskSwitch(this.syFlag);
},


resetInsured(actualValue) {
let vm = this;
vm.syRiskList.forEach((item, index) => {
if (['030101', '030103', '030108','030152'].indexOf(item.kindCode) != -1) {
vm.syRiskList[index].sumInsured = actualValue;
}
});
},

encapRiskSY() {
let vm = this;
let riskList = [];

if (vm.jqFlag) {
let jqRisk = utils.deepClone(vm.jqRisk);
jqRisk.startDate = utils.beautyFormatDate(`${jqRisk.startDate}`, 'yyyy-mm-dd hh:mm:ss');
jqRisk.electronicPolicyFlag = vm.electronicPolicyFlag ? '1' : '';
jqRisk.effectFlag = jqRisk.startDate.split(' ')[1] == '00:00:00' ? '0' : '1'; 
riskList.push(jqRisk);
}


if (vm.syFlag) {
let syRiskList = [];
let _syRiskList = utils.deepClone(vm.syRiskList);
let syRisk = utils.deepClone(vm.syRisk);

_syRiskList.forEach((item, index) => {
let disabledZzfw = vm.vas.includes(item.kindCode) && !vm.servicesRisk[item.kindCode];
if (item.checked && !item.disabled) {
delete item.checked;
delete item.disabled;
syRiskList.push(item);

vm.syRiskList[index].isShow = true;
} else {
vm.syRiskList[index].isShow = false;
}
});


let hasDeductibleRate = false;
for (let i = 0; i < syRiskList.length; i++) {
let _risk = syRiskList[i];
let _code = _risk.kindCode;
if (_code === '030101' || _code === '030102' || _code === '030104' || _code === '030105') {
let _rate_risk = syRiskList.filter(item => item.kindCode === `rate${_code}`)[0];
if (_rate_risk) {
_risk.deductibleRate = _rate_risk.rate || '0';
hasDeductibleRate = true;
} else {
_risk.deductibleRate = '0';
}
}




}


if (hasDeductibleRate) {
let deductible_risk = syRiskList.filter(item => item.kindCode === '021')[0];
if (!deductible_risk) {
syRiskList.push({
deductible: '',
kindCode: '021',
kindInd: '2',
quantity: '',
sumInsured: ''
});
}
} else {
let deductible_risk = syRiskList.filter(item => item.kindCode === '021')[0];
if (deductible_risk) {
syRiskList = syRiskList.filter(item => item.kindCode !== '021');
}
}

syRisk.coverageList = vm.choosenSylist = syRiskList.filter(item => item.kindCode.indexOf('rate') < 0);

syRisk.startDate = utils.beautyFormatDate(`${syRisk.startDate}`, 'yyyy-mm-dd hh:mm:ss');
syRisk.electronicPolicyFlag = vm.electronicPolicyFlag ? '1' : '';
syRisk.effectFlag = syRisk.startDate.split(' ')[1] == '00:00:00' ? '0' : '1'; 


let _chargingPileList = this.getChargingPileList || [];
let _hasChargingPileRisk = syRisk.coverageList.filter(x=>['030153', '030154'].includes(x.kindCode)) || [];
["030153", "030154"].forEach(_kindCode => {
let pile_item =_chargingPileList.filter(item => [item.lossKindCode, item.liabKindCode].includes(_kindCode));
let risk_item = syRisk.coverageList.filter(item => item.kindCode == _kindCode);
if (risk_item.length && pile_item.length) {
risk_item[0].quantity = pile_item.length;
risk_item[0].sumInsured = Number(risk_item[0].unitInsured) * Number(risk_item[0].quantity);
}
})
syRisk.chargingPileList = (_hasChargingPileRisk.length && _chargingPileList.length) ? _chargingPileList : null;

riskList.push(syRisk);
}
return riskList;
},

setPremium(riskList) {
let vm = this;
vm.calPremiumResult = { totalPremium: 0 };
riskList.forEach(risk => {
if (risk.riskCode == CONSTANTS.XNY_RISK_CODE) {

risk.coverageList.forEach(coveragItem => {
vm.calPremiumResult[coveragItem.kindCode] = parseFloat(coveragItem.grossPremium).toFixed(2);
if (coveragItem.kindCode === '030101' || coveragItem.kindCode === '030102' || coveragItem.kindCode === '030104' || coveragItem.kindCode === '030105') {
if (coveragItem.nonDeductiblePremium && coveragItem.nonDeductiblePremium !== '0') {
vm.calPremiumResult[`rate${coveragItem.kindCode}`] = parseFloat(coveragItem.nonDeductiblePremium).toFixed(2);
}
}
});
vm.calPremiumResult.syTotalPremium = risk.sumGrossPremium.toFixed(2) || "0"; 
vm.calPremiumResult.applySumDiscount = (risk.applySumDiscount * 10).toFixed(3); 
vm.calPremiumResult.totalPremium += risk.sumGrossPremium; 
vm.calPremiumResult.syTotalPremiumSaved = (risk.sumGrossPremium * ((1 - risk.applySumDiscount) / risk.applySumDiscount)).toFixed(2); 

} else if (risk.riskCode == "0301") {
vm.calPremiumResult.jqTotalPremium = risk.sumGrossPremium.toFixed(2) || "0"; 
vm.calPremiumResult.vhlTax = risk.vhlTax; 
vm.calPremiumResult.totalPremium += risk.sumGrossPremium; 
vm.calPremiumResult.totalPremium += (risk.vhlTax.sumPayTax || 0); 

}
});
vm.calPremiumResult.totalPremium = vm.calPremiumResult.totalPremium.toFixed(2); 
vm.setCalPremiumResult(vm.calPremiumResult);
},

validateLimit() {
let vm = this;
let check = {
msg: '',
valid: true
};
if(vm.syFlag) {

for (let i = 0; i < this.syRiskList.length; i++) {
let _risk = this.syRiskList[i];

if (!_risk.checked) {
continue;
}

if (_risk.kindCode === '030138') {
check = {msg: '新能源条款不能投保《发动机进水损坏除外险》，请知悉！', valid: false};
break;
}
}
}
return check;
},
validate() {
let vm = this;
let check = {
msg: '',
valid: true
};
if (!vm.jqFlag && !vm.syFlag) {
check = {
msg: '请至少选择一种险种',
valid: false
}
}
if (vm.syFlag && vm.choosenSylist.length == 0) {
check = {
msg: '请至少选择一种商业险险种',
valid: false
}
}
return check;
},

validateAllSyRisk() {
const timesObj = {
'030134': 'roadRescueService', //道路救援服务次数
'030135': 'vehicleSafetyInspect', //车辆安全检测次数
'030136': 'drivingServices', //代驾服务次数
'030137': 'inspectServices' //代为送检服务次数
};
for (let i = 0; i < this.syRiskList.length; i++) {
let _risk = this.syRiskList[i];

if (!_risk.checked) {
continue;
}

let insuranceType = this.getInsuranceType(_risk.kindCode);
let riskName = this.getRiskName(_risk.kindCode);
let validInfo = null;
switch (insuranceType) {
case 'input2':
case 'complex3':
let timesName = timesObj[_risk.kindCode];
let maxTime = this.switchList[timesName];
validInfo = this.validateTimes(_risk.quantity, riskName, maxTime);
break;
case 'input3':
if (_risk.kindCode === '030155') {

validInfo = this.validateOTA(_risk.sumInsured, riskName);
} else {
validInfo = this.validateSumInsured(_risk.sumInsured, riskName);
}
break;
case 'input4':
validInfo = this.validateSumInsured(_risk.unitInsured, riskName);
break;
case 'input6':
validInfo = this.validatePile(_risk.kindCode, riskName);
break;
default:
break;
}

if (validInfo && !validInfo.valid) {
return validInfo;
}
}

return { valid: true, msg: '' };
},

validateTimes(value, riskName, maxTime) {
maxTime = (maxTime || maxTime === 0) ? maxTime : 10;
let regPremium = /^[1-9]\d*$/;
if (!value && value !== 0) {
return { valid: false, msg: `请输入${riskName}次数` };
} else if (Number(value) < 1) {

return { valid: true, msg: '' };
} else if (Number(value) > maxTime) {
return { valid: false, msg: `${riskName}次数不能大于${maxTime}次` };
} else if (!regPremium.test(value)) {
return { valid: false, msg: `${riskName}次数只能为整数` };
} else {
return { valid: true, msg: '' };
}
},

validateSumInsured(value, riskName) {
let regPremium = /^\d+(?=\.{0,1}\d+$|$)/;
if (!value && value !== 0) {
return { valid: false, msg: `请输入${riskName}保额` };
} else if (Number(value) <= 0) {
return { valid: false, msg: `${riskName}保额不能小于或等于0` };
} else if (!regPremium.test(value)) {
return { valid: false, msg: `请输入正确的${riskName}保额` };
} else {
return { valid: true, msg: '' };
}
},

validateOTA(value, riskName) {
let regPremium = /^\d+(?=\.{0,1}\d+$|$)/;
if (!value && value !== 0) {
return { valid: false, msg: `请输入${riskName}保额` };
} else if (Number(value) <= 0) {
return { valid: false, msg: `${riskName}保额不能小于或等于0` };
} else if (!regPremium.test(value)) {
return { valid: false, msg: `请输入正确的${riskName}保额` };
} else if (!this.quoteInfo.vehicle.assistSoftName || !this.quoteInfo.vehicle.assistSoftPrice) {
return { valid: false, msg: `请填写${riskName}OTA清单` };
} else if(value > this.syRiskList[0].sumInsured) {
return { valid: false, msg: `OTA保额不能超过车损保额` };
} else {
return { valid: true, msg: '' };
}
},

validatePile(value, riskName) {
let pile_item = (this.getChargingPileList || []).filter(item => [item.lossKindCode, item.liabKindCode].includes(value)) || [];
if (!pile_item.length) {
return { valid: false, msg: `请填写${riskName}充电桩清单` };
}
return { valid: true, msg: '' };
},

validatePremium() {
for (let item in this.calPremiumResult) {
if (item.indexOf('0301') > -1) {
let premium = this.calPremiumResult[item]; 
let riskName = this.getRiskName(item);
if (['030134', '030135', '030136', '030137'].includes(item)) { //道路救援险、车辆安全检测、代驾服务、代为送检保费可以为0，但不能为空
if (!premium && premium !== 0) {
return { valid: false, msg: `${riskName}保费为空，不允许下一步` };
}
} else { //其他险别保费不能为0，也不能为空
if (!premium || premium == '0' || premium == '0.0' || premium == '0.00') {
return { valid: false, msg: `${riskName}保费为0，不允许下一步` };
}
}
}
}
return { valid: true, msg: '' };
},
reCalAmount() {
let vm = this;
vm.calAmount()
.catch(err => {
vm.isCalculatingPremiun = false;
if (!err.notRealPromiseException) { // 一切正常，只是通过 catch 方法来中止 promise chain
vm.$vux.toast.show({
text: err,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em'
});
}
});
},

calAmount() {
let vm = this;
let quoteData = {};

let riskList = this.encapRiskSY();

this.isShowAll = false;


let validata_limit = this.validateLimit();
if (!validata_limit.valid) {
return Promise.reject(validata_limit.msg);
}

let validate = this.validate();
if (!validate.valid) {
return Promise.reject(validate.msg);
}


let validate_risk = this.validateAllSyRisk();
if (!validate_risk.valid) {
return Promise.reject(validate_risk.msg);
}


if (!vm.isCalculatingPremiun) {
vm.isCalculatingPremiun = true;
}

if (vm.quoteInfo.shanghai && riskList && (riskList[0].vhlTax || riskList[1].vhlTax)) {
if (riskList[0].vhlTax) {
riskList[0].vhlTax.relifReason = '';
riskList[0].vhlTax.taxItemDetailCode = '';
} else {
riskList[1].vhlTax.relifReason = '';
riskList[1].vhlTax.taxItemDetailCode = '';
}
}

let _syRisk = riskList.find(x => x.riskCode == CONSTANTS.XNY_RISK_CODE);
if (_syRisk) {
let risk_item = _syRisk.coverageList.find(item => item.kindCode == '030155');
if (risk_item) {
quoteData.vehicle = {
assistDrivingFun: '1',
assistSoftName: vm.quoteInfo.vehicle.assistSoftName,
assistSoftPrice: vm.quoteInfo.vehicle.assistSoftPrice,
}
}
}
quoteData.riskList = riskList;
quoteData.quotationWay = '0';
return $http.quote({
query: {
flowId: this.flowId,
},
data: quoteData,
showLoading: false,
closeLoading: false,
})
.then(res => {

if (res.result && res.result.riskList && res.result.riskList.length && res.result.riskList.some(i => i.ilogInfos && i.ilogInfos.length)) {
const riskList = res.result.riskList || []
let touchCRuleMark = false
riskList.forEach(item => {
touchCRuleMark = item.ilogInfos.some(i => i.preRuleType === 'C')
})
if (touchCRuleMark) {
this.$vux.alert.show({
title: '温馨提示',
content: '暂不支持您的爱车投保',
});
return Promise.reject({
notRealPromiseException: true,
});
}
}
let jqRisk = {};
if(!utils.isEmpty(res.result)){
let riskList = res.result && res.result.riskList;
if(riskList && riskList.length){
riskList.forEach((item)=>{
if(item.riskCode==='0301'){
jqRisk = item;
}
})
}
if(!utils.isEmpty(jqRisk) && jqRisk.vhlTax && jqRisk.vhlTax.taxRelifFlag === '04' || jqRisk.vhlTax.taxRelifFlag === '05'){

if(jqRisk && jqRisk.vhlTax && (!jqRisk.vhlTax['taxCompancyCode'] || !jqRisk.vhlTax['taxCompancyName'] || !jqRisk.vhlTax['paidFreeCertificate'])){
this.$vux.alert.show({
title: '温馨提示',
content: '暂不支持您的爱车投保',
});
return Promise.reject({
notRealPromiseException: true,
});
}
}
}
if (!(vm.getSwitchList.ocrInsuredSwitch && res.resultCode === '0')) {

vm.isCalculatingPremiun = false;
}
let newQuoteInfo = utils.deepClone(res.result);
if(!utils.isEmpty(newQuoteInfo) && !utils.isEmpty(newQuoteInfo.riskList) ){
vm.handleZzfw(newQuoteInfo && newQuoteInfo.riskList);
}
if (res.resultCode == 0) {
if (!newQuoteInfo) return
if (!newQuoteInfo.base) return








if (vm.getSwitchList.ocrInsuredSwitch) {

vm.initUploaderInstance(res.result).then((historyImg) => {

if (historyImg && historyImg.length) {
console.log('先删除再上传');
vm.uploaderInstance.deleteFile({
imgIdList: historyImg.map(item => item.imgId),
success: () => {

vm.imgUpload(newQuoteInfo)
},
error: err => {
console.log(err);
}
})
} else {
console.log('直接上传');
vm.imgUpload(newQuoteInfo)
}
})
}

vm.setPremium(newQuoteInfo.riskList);

/* newQuoteInfo.riskList.forEach(item => {
item.clauseList = (item.coreClauseList || []).filter((clauseItem)=>{
return !(clauseItem.isNeeded === '0' && clauseItem.isModify === '1');
});
}); */

vm.setQuoteInfo(newQuoteInfo);

vm.officialApply();
} else if (res.resultCode == '3') { // 重复投保 or 转保 or 车型不一致
let reInsureList = newQuoteInfo.reInsureList;

if (reInsureList && reInsureList.length == 2) {
if (!reInsureList[0].expireDate || !reInsureList[1].expireDate) {
return Promise.reject(res.errorMsg);
} else {

reInsureList = reInsureList.filter(item => {
return item.kindCode == '0301';
});
let expireDate = utils.translateTimeDate(reInsureList[0].expireDate + ":00:00"); 
let tempTime = utils.translateTimeDate(vm.jqRisk.startDate); 
let between = utils.daysBetween(tempTime, expireDate);
if (between <= 0) {
return Promise.reject(res.errorMsg);
}
}
} else if (reInsureList && reInsureList.length == 1 && reInsureList && reInsureList.riskCode == '0301') {
if (!reInsureList[0].expireDate) {
return Promise.reject(res.errorMsg);
} else {
let expireDate = utils.translateTimeDate(reInsureList[0].expireDate + ":00:00"); 
let tempTime = utils.translateTimeDate(vm.jqRisk.startDate); 
let between = utils.daysBetween(tempTime, expireDate);
if (between < 0) {
return Promise.reject(res.errorMsg);
}
}
} else {
return Promise.reject(res.errorMsg);
}


var carModelInfos = newQuoteInfo.carModelInfos;
if (carModelInfos) { // 车型编码不一致
return Promise.reject(res.errorMsg);
}



Toast(res.errorMsg);

vm.setQuoteInfo(newQuoteInfo);
vm.setPremium(newQuoteInfo.riskList);

vm.officialApply();
} else {
return Promise.reject(res.errorMsg);
}
})
.then(res => {

vm.hasCalPremiunFlag = true;
})
.catch(err => {
return Promise.reject(err);
})
},

imageUpdateStatus(quoteInfo) {
const vm = this
const imageIds = quoteInfo.riskList.map((item) => item.imageId)
const quotationNos = quoteInfo.riskList.map(
(item) => item.quotationNo
)
const data = {
imageIds,
quotationNos,
proposalNo: '',
status: '10',
}
$http
.updateImgStatus({
data,
})
.then((res) => {
vm.isCalculatingPremiun = false;
})
.catch((err) => {
vm.isCalculatingPremiun = false;
console.log(err)
})
},

getTokenToImageUpload(quoteInfo) {

const imageIds = quoteInfo.riskList.map((item) => item.imageId)

const imageItemInfos = [
{

type: '1',
itemName: this.applicantTips ? quoteInfo.applicant.name : quoteInfo.owner.name,
itemNumber: this.applicantTips ? quoteInfo.applicant.identifyNumber : quoteInfo.owner.identifyNumber,
itemType: this.applicantTips ? quoteInfo.applicant.identifyType : quoteInfo.owner.identifyType
},
{

type: '2',
itemName: this.insuredTips ? quoteInfo.insured.name : quoteInfo.owner.name,
itemNumber: this.insuredTips ? quoteInfo.insured.identifyNumber : quoteInfo.owner.identifyNumber,
itemType: this.insuredTips ? quoteInfo.insured.identifyType : quoteInfo.owner.identifyType
},
{

type: '4',
itemName: quoteInfo.owner.name,
itemNumber: quoteInfo.owner.identifyNumber,
itemType: quoteInfo.owner.identifyType,
},
{

type: '5',
itemName: quoteInfo.vehicle.licenseNo,
itemNumber: quoteInfo.vehicle.frameNo,
},
]
const data = {
companyCode: quoteInfo.base.companyCode || '',
imageIds,
imageItemInfos,
operator: quoteInfo.base.operatorCode || '',
proposalNo: '',
step: '投保',
}
const option = {
data,
}
return $http
.getImageToken(option)
.then((res) => {
if (res.resultCode == '0') {
return res.result.token
} else {
Toast(res.errorMsg || '获取token失败')
}
})
.catch((err) => {
Toast(res.errorMsg || '获取token失败')
console.log(err)
})
},

initUploaderInstance(quoteInfo) {
const vm = this
return new Promise((resolve, reject) => {
const uploaderInstance = new SNKH5Uploader({
api: {
base: cloudImageBaseURL,

},
getToken: function(params) {
vm.getTokenToImageUpload(quoteInfo).then((token) => {
vm.uploadToken = token
params.success({
token
})
})
},
})
uploaderInstance.init({
success: function() {
uploaderInstance.queryFiles({

imgIdList: [],
success: res => {
resolve(res)
},
error: error => {
resolve(error.data || [])
console.log(error)
}
})
},
error: function(e) {
console.log(e)
},
})
vm.uploaderInstance = uploaderInstance
})
},

getFileFromUrl(url, fileName, code) {
return new Promise((resolve, reject) => {
const suffix = fileName.split('.').pop()
let blob = null;
const xhr = new XMLHttpRequest();
xhr.open("GET", url);
xhr.setRequestHeader('Accept', 'image/' + suffix);
xhr.responseType = "blob";

xhr.onload = () => {

blob = xhr.response;
let file= new File([blob], fileName, { type: 'image/' + suffix });
file.code = code

resolve(file);
};
xhr.onerror = (e) => {
reject(e)
};

xhr.send();
});
},
getImgFile() {
const arr = [
{
name: 'owner',
code: 'S001_0601'
},
{
name: 'vehicle',
code: 'S001_0701'
},
{
name: 'insured',
code: 'S001_0401'
},
{
name: 'applicant',
code: 'S001_0301'
}
]
const cacheRecordInfo = this.cacheRecordInfo
const proFiles = []
arr.forEach(item => {
const name = item.name
if (name === 'owner') {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
} else if (name === 'vehicle') {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
if (cacheRecordInfo[name].backSrc && cacheRecordInfo[name].backName) {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
}
} else if (name === 'insured') {
if (!this.insuredTips) {
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].justSrc, cacheRecordInfo['owner'].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].backSrc, cacheRecordInfo['owner'].backName, item.code))
} else {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
}
} else if (name === 'applicant') {
if (!this.applicantTips) {
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].justSrc, cacheRecordInfo['owner'].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].backSrc, cacheRecordInfo['owner'].backName, item.code))
} else {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
}
}
})
return proFiles
},

imgUpload(newQuoteInfo) {
const vm = this
Promise.all(this.getImgFile()).then(files => {

const proUploads = []
files.forEach(file => {
const code = file.code
proUploads.push(vm.uploadImg(file, code))
})
Promise.all(proUploads).then(res => {

vm.imageUpdateStatus(newQuoteInfo)
}).catch(err => {

vm.isCalculatingPremiun = false;
console.log('err', err);
})
}).catch(err => {

vm.isCalculatingPremiun = false;
console.log('err', err);
})
},
uploadImg(file, code) {
return new Promise((resolve, reject) => {
let quality = 0

const uploaderInstance = this.uploaderInstance
if (file.size > 1 * 1024 * 1024) {
quality = 0.9
}
uploaderInstance.fileSelected(file, result => {
result.uploadNode = '投保' 
uploaderInstance.upload({
file: result.file,
quality: quality || 1,
pathData: {

typeCode: code,
},
VoData: result,
success: (res) => {
console.log('res-uploadImg-', res)
resolve(res)
},
error: (err) => {
resolve(err)
console.log('error-uploadImg', err)

},
})
})
})
},

syRiskSwitch(syFlag) {
if (!syFlag) { // 取消
this.syRiskList.forEach((item, riskIndex) => {
item.relatedInd = 0;
item.checked = false;
});
}
},

handleRiskClick(item) {
if (!this.getRiskLimits(item.kindCode)) {
let relation = this.riskTips[item.kindCode]; 
let rely = relation && relation.rely;
if (rely && rely.length > 0) {
this.$vux.confirm.show({
title: '提示',

content: `亲，请先投保主险！`,
showCancelButton: false
});
}
}
},
otaConfirm(item) {

if (!item.checked) {
Toast(`亲，请先投保${this.riskTips[item.kindCode].name}！`);
return false;
}
let vm = this,
valOpt = {
assistDrivingFun: this.quoteInfo.vehicle.assistDrivingFun,
assistSoftName: this.quoteInfo.vehicle.assistSoftName,
assistSoftPrice: this.quoteInfo.vehicle.assistSoftPrice,
},
title = 'OTA驾驶软件明细',
content = `<div class="item-row">
<label>
软件名称:&nbsp;
<input id="assist_soft_name" placeholder="请输入软件名称" class="item-prompt-input" type="text" maxlength="50" value="${valOpt.assistSoftName||''}">
</label>
</div>
<div class="item-row">
<label>
软件价格:&nbsp;
<input id="assist_soft_price" placeholder="请输入软件价格" class="item-prompt-input" type="text" maxlength="20" value="${valOpt.assistSoftPrice||''}">&nbsp;元
</label>
</div>`;
setTimeout(() => {
vm.$vux.confirm.show({
title,
content,
closeOnConfirm: false,
onConfirm (v) {
let assistDrivingFun = '1',
assistSoftName = document.getElementById('assist_soft_name').value.trim(),
assistSoftPrice = document.getElementById('assist_soft_price').value.trim();
if (assistDrivingFun == '1') {

let validate = {msg: '', valid: true};
if (!assistSoftName) {
validate = {msg: '请输入软件名称', valid: false};
} else if (!assistSoftPrice) {
validate = {msg: '请输入软件价格', valid: false};
} else if (isNaN(assistSoftPrice)) {
validate = {msg: '请输入数字', valid: false};
} else if (Number(assistSoftPrice) < 0) {
validate = {msg: '价格不得小于零', valid: false};
} else if (Number(assistSoftPrice) > vm.syRiskList.find(item => item.kindCode === '030101').sumInsured) {
validate = {msg: 'OTA保额不能超过车损保额', valid: false};
}
if (!validate.valid) {
Toast(validate.msg);
return;
}
}
if (assistSoftName !== valOpt.assistSoftName) {

vm.hasCalPremiunFlag = false;
}
if (assistSoftPrice !== valOpt.assistSoftPrice) {

vm.hasCalPremiunFlag = false;

vm.syRiskList.find(item => item.kindCode === '030155').sumInsured = assistSoftPrice;
}

vm.setOtaVehicle({
assistDrivingFun,
assistSoftName,
assistSoftPrice
})
vm.$vux.confirm.hide();
}
})
}, 200);
},
handleRiskCheck(item) {

if (item.checked && !this.syFlag) {
this.syFlag = true;
}

if (item.kindCode === '030101' && item.checked) {

let _v = this.quoteInfo.vehicle;
let _c = _v.ciModelCode === 'BXPTYXCL9999' && _v.carKindCode === '100' && ['纯电动', '燃料电池'].indexOf(_v.powerType) !== -1 && !_v.pureRange;
if (_c) {
Toast('投保车损险必录纯电续航里程数！');
}
}

if (item.kindCode === '030105' && item.checked) {
this.setRiskState({ kindCode: '030104', checked: true });
}

if (item.kindCode === '030104' && !item.checked) {
this.setRiskState({ kindCode: '030105', checked: false });
}

if (item.kindCode === '030155' && item.checked) {

this.otaConfirm(item);
}

if ((item.kindCode === '030153' || item.kindCode === '030154') && item.checked) {

this.toCharging(item.kindCode, this.syRisk.startDate);
}




if (!item.checked) {
let secondarys = [];
for (let i = 0; i < RISK_LIMITS_LINK_XNY.length; i++) {
if (RISK_LIMITS_LINK_XNY[i].primary === item.kindCode) {
secondarys = RISK_LIMITS_LINK_XNY[i].secondary;
break;
}
}
if (secondarys.length > 0) {
for (let i = 0; i < secondarys.length; i++) {
let riskCode = secondarys[i];
let primarys = this.findPrimary(riskCode, RISK_LIMITS_LINK_XNY);
let num = 0;
for (let j = 0; j < primarys.length; j++) {
let _checked = this.syRiskList.find(item => item.kindCode === primarys[j]).checked;
!_checked && num++;
}
if (primarys.length === num) {
this.setRiskState({ kindCode: riskCode, checked: false });
}
}
}
}
},
findPrimary(riskCode, riskList) {
let primarys = [];
for (let i = 0; i < riskList.length; i++) {
let secondarys = riskList[i].secondary;
secondarys.indexOf(riskCode) > -1 && primarys.push(riskList[i].primary);
}
return primarys;
},
setRiskState(obj) {
for (let i = 0; i < this.syRiskList.length; i++) {
if (obj.kindCode === this.syRiskList[i].kindCode) {
this.syRiskList[i].checked = obj.checked;
break;
}
}
},

handlePickerChange(item) {
if (item.kindCode === '030102') {
for (let i = 0; i < this.syRiskList.length; i++) {
if (this.syRiskList[i].kindCode === '030120') {
this.syRiskList[i].sumInsured = item.sumInsured;
break;
}
}
}
},

handleInputChange(item) {
let inputs = ['030141', '030142', '030145', '030146']; 
if (inputs.indexOf(item.kindCode) > -1) {
item.sumInsured = item.unitInsured * item.quantity;
}
},

isCustomCoverage030154(_val) {
let status = true;
if (['10000', '20000', '30000', '50000', '100000', '200000', '300000', '500000'].includes(_val)) {

status = false;
}
return status;
},

handlePickerShow030154() {

let _val = this.isCustomCoverage030154(this.temp030154Val) ? this.temp030154Val : '';
this.setRiskOption030154(_val);
},
handlePickerHide030154(closeType) {
let vm = this;
let _risk_cost_030154 = vm.syRiskList.find(item => item.kindCode === '030154') || {};
if (closeType) {
if (vm.isCustomCoverage030154(vm.temp030154Val)) {

vm.$vux.confirm.prompt('保额需大于50万', {
title: '充电桩责任险保额',
inputAttrs: { maxlength: 20 },
closeOnConfirm: false,
onCancel() {
if (vm.temp030154Val !== _risk_cost_030154.unitInsured) {
vm.temp030154Arr = [_risk_cost_030154.unitInsured]; 
}
},
onConfirm(value) {
let minAmt = 500000; 
let maxAmt = 99999999;
let err = '';
let reg = /^[1-9]\d*$/; 
if(!reg.test(value)) {
err = '请输入合法的保额';
}
else if(Number(value) > maxAmt) {
err = '保额需小于'+maxAmt;
}
else if(Number(value) <= minAmt) {
err = '保额需大于'+minAmt;
}
if (err) {
Toast(err);
return false;
} else {
if (vm.temp030154Val !== value) {
vm.temp030154Arr = [value]; 
}
if (_risk_cost_030154.unitInsured !== value) {
_risk_cost_030154.unitInsured = value; 
}
}
vm.$vux.confirm.hide();
}
});
} else {
if (_risk_cost_030154.unitInsured !== vm.temp030154Val) {

_risk_cost_030154.unitInsured = vm.temp030154Val;
}
}
}
},
},
watch: {
syRiskList: {
deep: true,
handler(newVal, oldVal) {
this.hasCalPremiunFlag = false;
}
},
syRisk: {
deep: true,
handler(newVal, oldVal) {
this.hasCalPremiunFlag = false;
}
},
jqRisk: {
deep: true,
handler(newVal, oldVal) {
this.hasCalPremiunFlag = false;
}
},
jqFlag(val) {
this.hasCalPremiunFlag = false;
},
syFlag(val) {
this.hasCalPremiunFlag = false;

this.syRiskSwitch(val);
},
},

created() {
if (this.isSdjg) {
this.syRiskList = utils.deepClone(CONSTANTS.COVERAGE_List_XNY_Sd).filter(item => item.kindCode !== '021')
}

this.initalRiskOption();


this.setSeatCount();


this.initalRiskLimit();


this.initalRiskValue();
let vm = this;
vm.quoteInfo.jqFlag ? vm.jqFlag = true : '';
vm.quoteInfo.syFlag ? vm.syFlag = true : '';

vm.queryVhlTaxRelief()
.then(() => {


return Promise.all([vm.getInitRiskInfo(), vm.getQuotaLimitList()])
})
.then(() => {


return Promise.all([vm.depreciation(), vm.queryVhlTaxRelief()])
.then(resultList => {
let actualValue = resultList[0]; 
this.initRiskInfoShowing(actualValue);
return this.calAmount();
})
.catch(err => {
vm.isCalculatingPremiun = false;


if (!this.isSdjg) {
vm.clearRiskList();
vm.officialApply();
}
if (!err.notRealPromiseException) { // 一切正常，只是通过 catch 方法来中止 promise chain
Toast(err);
}
});
})
.catch(err => {
vm.isCalculatingPremiun = false;
let errMsg = err || "险种初始化出错！";
Toast(errMsg);
});



let nowTime = new Date();
this.dateControl = {
startDate: utils.beautyFormatDate(new Date(), 'yyyy-mm-dd'),
minHour: new Date().getHours(),
}
},
mounted() {
utils.stopVideo(this.flowId).then(()=>{
utils.startVideo('','',() => {
utils.createOperationVideo("LOAD_PAGE","选择方案");
})
})
},
beforeDestroy(){
utils.stopVideo(this.flowId).then(()=>{
utils.startVideo()
})
},
beforeRouteLeave(to, from, next) {

from.meta.keepAlive = to.name === 'ChargingPile';
next();
},
activated(){

if (this.hasCalPremiunFlag) {
if (JSON.stringify(this.syRisk.chargingPileList) !== JSON.stringify(this.quoteInfo.riskList.find(x => x.riskCode === CONSTANTS.XNY_RISK_CODE).chargingPileList)) {

if (this.syRisk.chargingPileList != this.quoteInfo.riskList.find(x => x.riskCode === CONSTANTS.XNY_RISK_CODE).chargingPileList) {

this.hasCalPremiunFlag = false;
}
}
}
},
}
